<template>
  <form novalidate>
    <h4 class="h4 text--bold text--uppercase">
      Sobre posibles nuevas acciones y conclusiones de la visita
    </h4>
    <form-group :error="errors.has('nuevas-recomendaciones') && submitted">
      <label class="form__label form__label--required">
        11. ¿Se dieron nuevas recomendaciones?
      </label>
      <div class="radio radio--azul">
        <input
          :disabled="!editando"
          type="radio"
          v-model="form.nuevasRecomendaciones"
          id="si-recomendaciones"
          name="nuevas-recomendaciones"
          v-validate="'required'"
          value="Si"
        >
        <label class="form__label" for="si-recomendaciones">Si</label>
      </div>
      <div class="radio radio--azul">
        <input
          :disabled="!editando"
          type="radio"
          v-model="form.nuevasRecomendaciones"
          id="no-recomendaciones"
          name="nuevas-recomendaciones"
          v-validate="'required'"
          value="No"
        >
        <label class="form__label" for="no-recomendaciones">No</label>
      </div>
    </form-group>

    <form-group
      v-if="form.nuevasRecomendaciones === 'Si'"
      :error="errors.has('cuales-recomendaciones') && submitted"
      class="identado"
    >
      <input
        data-vv-validate-on="blur"
        :disabled="!editando"
        type="text"
        class="form__input"
        v-model="form.cualesRecomendaciones"
        name="cuales-recomendaciones"
        required
        v-validate="'required'"
      >
      <label class="form__label">
        11.1 ¿Cuál o cuáles?
      </label>
    </form-group>

    <form-group>
      <textarea
        data-vv-validate-on="blur"
        :disabled="!editando"
        type="text"
        class="form__input"
        v-model="form.conclusionesVisita"
        name="conclusiones-visita"
      />
      <label class="form__label">
        12. Conclusiones de la visita (agregue lo que desee o
        cualquier cosa que no estuviera en las preguntas anteriores y
        quiere reportar, por ejemplo cosas positivas y negativas, etc.)
      </label>
    </form-group>
  </form>
</template>

<script>
export default {
  props: {
    editando: Boolean,
    submitted: Boolean,
    form: Object,
  },
};
</script>
